import { apiGetOrderDetails, apiGetOrderStatusData } from "Root/api/apiProfile";
import toastService from "Root/profile/toastService";
import { setOrderDetails, setOrderStatusData } from "../../actionCreators/makeActionCreator";
export const LoadOrderDetailsThunk = (key) => async (dispatch) => {
    try {
        const data = await apiGetOrderDetails(key);
        dispatch(setOrderDetails({ ...data }));
    }
    catch (e) {
        toastService.errorMessage(e);
    }
};
export const LoadOrderStatusDataThunk = () => async (dispatch) => {
    try {
        const data = await apiGetOrderStatusData();
        dispatch(setOrderStatusData(data));
    }
    catch (e) {
        toastService.errorMessage(e);
    }
};
